import React from "react";
import { Formik, Form, FieldArray } from "formik";
import { FormikFormGroup, FormikInput, Icon, ModalSubmit } from "components/common";
import { Modal, Row, Col, Button, Alert } from "components/bootstrap";
import useRepositories from "./hooks/useRepositories";
const HadoopStorageRepositoryModalForm = ({ hideModal }) => {
  const { onCreateRepository } = useRepositories();
  const handleSubmit = (values) => {
    const conf = values.confArray.reduce((acc, { key, value }) => {
      if (key) acc[key] = value;
      return acc;
    }, {});
    const { confArray: _confArray, ...valuesWithoutConfArray } = values;
    const valuesWithConf = { ...valuesWithoutConfArray, conf };
    onCreateRepository({ type: "hdfs", ...valuesWithConf }).then(() => hideModal());
  };
  const initialValues = {
    name: "",
    uri: "",
    path: "",
    load_defaults: true,
    conf: {},
    confArray: []
  };
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit: handleSubmit, initialValues }, ({ isSubmitting, isValidating, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      label: "Name",
      name: "name",
      help: "Name of your warm storage repository. Must be unique.",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(FormikFormGroup, { type: "text", label: "Uri", name: "uri", help: "Uri of the nameserver", required: true }), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      label: "Path",
      name: "path",
      help: "Path of the warm storage repository",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      label: "Load defaults",
      name: "load_defaults",
      help: "Whether to load the default Hadoop configuration or not. (Enabled by default)",
      type: "checkbox"
    }
  ))), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h5", null, /* @__PURE__ */ React.createElement("b", null, "Configuration properties")), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement("code", null, "conf.", "<", "key", ">"), /* @__PURE__ */ React.createElement("p", null, "Inlined configuration parameter to be added to Hadoop configuration. (Optional) Only client oriented properties from the hadoop core and hdfs configuration files will be recognized by the plugin.")), /* @__PURE__ */ React.createElement(FieldArray, { name: "confArray" }, ({ remove, push }) => /* @__PURE__ */ React.createElement("div", null, values.confArray.length > 0 && values.confArray.map((pair, index) => /* @__PURE__ */ React.createElement(Row, { key: pair.id }, /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: `${pair.key}-key`,
      name: `confArray.${index}.key`,
      placeholder: "Key",
      type: "text"
    }
  )), /* @__PURE__ */ React.createElement(Col, { md: 5 }, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      id: `${pair.key}-value`,
      name: `confArray.${index}.value`,
      placeholder: "Value",
      type: "text"
    }
  )), /* @__PURE__ */ React.createElement(Col, { md: 1 }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: () => remove(index) }, /* @__PURE__ */ React.createElement(Icon, { name: "delete" }))))), /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      type: "button",
      onClick: () => push({ id: `newRow-${(/* @__PURE__ */ new Date()).getTime()}`, key: "", value: "" })
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "add" }),
    " Add Conf property"
  )))))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      submitButtonText: "Create",
      submitLoadingText: "Creating...",
      onCancel: hideModal,
      disabledSubmit: isValidating,
      isSubmitting
    }
  ))));
};
export default HadoopStorageRepositoryModalForm;
